// src/encounter/services/use-save-flags.ts
// POST /api/Patients/CreateFlag — persists the WHOLE flag list (list-replace). On success,
// invalidate the patient summary so the rail reflects the change. Body built by
// buildCreateFlagBody (never a partial list). Patients monolith (401-verified 2026-06-14).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import type { CreateFlagItem } from '@/types/flags-api';

export function useSaveFlags(patientId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateFlagItem[]) => {
      return post<string>('/api/Patients/CreateFlag', body);
    },
    onSuccess: () => {
      // Match use-patient-summary's queryKey (confirmed: ['patient-summary', patientId]).
      qc.invalidateQueries({ queryKey: ['patient-summary', patientId] });
    },
  });
}
